import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import CreateEmpresas from "../../clientes/Empresas/Create.js"


import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fechaContacto: new Date(),
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.proyectos.contactos.create}
                onSubmit={() => this.props.onSubmit()}
                successMessage={"El Contacto ha sido creado con éxito."}
                title={"Nuevo Contacto"}
                buttonTitle={"Nuevo Contacto"}
                buttonIcon={"fa fa-plus fa-lg"}
                saveButton={true}
                closeButton={true}>
                <Row>
                    <Col className="col-4">
                        <Label>Fecha de Contacto</Label>
                    </Col>
                    <Col className="col-8">
                        <Datetime
                            className="display-inline-block"
                            timeFormat="HH:mm"
                            dateFormat="DD/MM/YYYY"
                            closeOnSelect={true}
                            inputProps={{ name: 'fechaContacto' }}
                            value={this.state.fechaContacto}
                            onChange={(e) => this.setState({ fechaContacto: e._d })}
                        />
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4">
                        <Label>Empresa/Organización</Label>
                    </Col>
                    <Col className="col-8">
                        <ParadigmaAsyncSeeker Create={CreateEmpresas} fieldName={"empresa_id"} url={api.clientes.empresas.select} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4">
                        <Label>Email</Label>
                    </Col>
                    <Col className="col-8">
                        <Input type="text" name="email"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4">
                        <Label>Teléfono</Label>
                    </Col>
                    <Col className="col-8">
                        <Input type="text" name="telefono"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-12">
                        <Label>Observaciones</Label>
                        <Input rows={10} type="textarea" name="observaciones" />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento0/Create.js